import { getFieldAndBindPath } from "../../util/schema-helper.js";
import { createColDef } from "../../util/z-grid-helper.js";
import { uuidv4 } from "../../util/utils.js";
import { getUrlOfLink2One } from "../../util/formatter.js";

const COMPONENT_NAME = "z-field-only" ;


function parseConditionPart(part, currentWhere){
    const equalIndex = part.indexOf("=") ;
    if(equalIndex !== -1){
        const colName = part.substring(0, equalIndex).trim();
        const value = part.substring(equalIndex+1).trim();
        if(currentWhere.$or||currentWhere.$and){
            let wherePart = {};
            wherePart[colName] = value ;
            (currentWhere.$or||currentWhere.$and).push(wherePart) ;
        }else{
            currentWhere[colName] = value ;
        }
    }else{
        let firstSpace = part.indexOf(" ") ;
        if(firstSpace !== -1){
            const colName = part.substring(0, firstSpace);
            let remainingPart = part.substring(firstSpace).trim() ;
            let afterOpeSpace = remainingPart.indexOf(" ") ;
            if(afterOpeSpace !== -1){
                let ope = remainingPart.substring(0, afterOpeSpace).toLowerCase();
                let value = remainingPart.substring(afterOpeSpace).trim();
                if(ope[0] !== "$"){
                    ope = "$"+ope ;
                }
                if(ope === "$in"){
                    value = value.split(",").map((v)=>{ return v.trim() ;}) ;
                }
                let valueWithOpe = {} ;
                valueWithOpe[ope] = value ;
                if(currentWhere.$or||currentWhere.$and){
                    let wherePart = {};
                    wherePart[colName] = valueWithOpe ;
                    (currentWhere.$or||currentWhere.$and).push(wherePart) ;
                }else{
                    currentWhere[colName] = valueWithOpe ;
                }
            }
        }
    }
}

export default function register(){
    class FieldOnlyComponent extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback(){
            this.connected = true ;
            this.cols = Array.prototype.slice.apply(this.querySelectorAll("z-col")) ;
           this.innerHTML = "" ;
           this.currentModel = null;

           if(!this.innerHTML.trim() && this.hasAttribute("z-model")){
                this.initField() ;
            }else{
                this.input = this.firstElementChild ;
            }
            const {field} = this.prepareFieldAndBindPath() ;
            this.field = field;

            if(this.customValidity){
                this.input.setCustomValidity(this.customValidity) ;
            }
            this.applyReadonly() ;
            this.applyRequired() ;
            this.applyPlaceholder() ;
            this.applyCopyAttr() ;
        }


        prepareFieldAndBindPath(){
            this.currentModel = this.getAttribute("z-model") ;
            if(!this.currentModel){
                return { field: null, bindPath: null} ;
            }
            if(this.currentModel[0]==="{"){
                return { field: JSON.parse(this.currentModel), bindPath: null} ;
            }
            return getFieldAndBindPath(this.currentModel, this.getAttribute("z-app")) ;
        }

        initField(){
            if(this.currentModel === this.getAttribute("z-model")){
                return ;
            }
            this.currentModel = this.getAttribute("z-model") ;

            if(this.innerHTML.trim()){
                return;
            }

            let {field, bindPath} = this.prepareFieldAndBindPath() ;

            this.input = null;

            if(!this.hasAttribute("z-bind") && bindPath){
                this.setAttribute("z-bind", bindPath.join(".")) ;
            }

            if(!field){ 
                field = { type: "string" } ;
            }

            this.field = field ;


            if(!field.type && field.references){
                field.type = "search" ;
            }

            let schema = window.APP.schema ;
            if(this.hasAttribute("z-app")){
                schema = window.APPS[this.getAttribute("z-app")].schema ;
            }

            if(field.type === 'string' || field.type === 'phone'|| field.type === 'email' 
                || field.type === 'password' || field.type === 'color'){
                this.input = document.createElement("INPUT") ;
                this.input.className = "form-control" ;
                if(field.type === 'string'){
                    this.input.type = "text" ;
                } else if(field.type === 'phone'){
                    this.input.type = "tel" ;
                } else if(field.type === 'email'){
                    this.input.type = "email" ;
                } else if(field.type === 'password'){
                    this.input.type = "password" ;
                } else if(field.type === 'color'){
                    this.input.type = "color" ;
                }
                if(field.name){
                    this.input.name = field.name ;
                }
                if(field.size){
                    this.input.setAttribute("maxlength", field.size) ;
                }
            } else if (field.type === 'checkbox'){
                this.input = document.createElement("INPUT") ;
                this.input.type = "checkbox" ;
                this.input.className = "form-check-input" ;
            } else if (field.type === 'boolean'){
                field.values = {
                    true: window.tr("global.yes"),
                    false: window.tr("global.no"),
                } ;
                
                this.input = document.createElement("z-radio") ;
                
                if(this.currentModel[0]==="{"){
                    this.input.setAttribute("z-model", JSON.stringify(field)) ;
                }else{
                    this.input.setAttribute("z-model", this.getAttribute("z-model")) ;
                }
                if(this.hasAttribute("z-app")){
                    this.input.setAttribute("z-app", this.getAttribute("z-app")) ;
                }
            } else if (field.type === 'double' || field.type === 'integer'){
                this.input = document.createElement("z-number") ;
                this.input.setAttribute("z-type", field.type) ;
                if(field.size){
                    this.input.setAttribute("size", field.size);
                }
                if(this.hasAttribute("z-decimaldigits")){
                    this.input.setAttribute("z-decimaldigits", this.getAttribute("z-decimaldigits")) ;
                }
            } else if (field.type === 'icon'){
                this.input = document.createElement("z-icon-picker") ;
            } else if (field.type === 'binary'){
                this.input = document.createElement("z-binary") ;
                if(this.hasAttribute("z-app")){
                    this.input.setAttribute("z-app", this.getAttribute("z-app")) ;
                }
                if(field.accept_file_types){
                    this.input.setAttribute('accept', field.accept_file_types) ;
                }
            } else if (field.type === 'media'){
                this.input = document.createElement("z-media") ;
                if(this.hasAttribute("z-app")){
                    this.input.setAttribute("z-app", this.getAttribute("z-app")) ;
                }
                if(this.hasAttribute("z-media-max-width")){
                    this.input.setAttribute("z-media-max-width", this.getAttribute("z-media-max-width")) ;
                }
                if(this.hasAttribute("z-media-max-size")){
                    this.input.setAttribute("z-media-max-size", this.getAttribute("z-media-max-size")) ;
                }
                if(this.hasAttribute("z-media-jpeg-quality")){
                    this.input.setAttribute("z-media-jpeg-quality", this.getAttribute("z-media-jpeg-quality")) ;
                }
            } else if (field.type === 'date' || field.type === 'datetime' || field.type === 'time'){
                this.input = document.createElement("z-date") ;
                this.input.setAttribute("z-type", field.type) ;
            // } else if (field.type === 'html'){
            //     this.input = document.createElement("z-html") ;
            } else if (field.type === 'radio'){
                this.input = document.createElement("z-radio") ;
                this.input.setAttribute("z-model", this.getAttribute("z-model")) ;
                if(this.hasAttribute("z-app")){
                    this.input.setAttribute("z-app", this.getAttribute("z-app")) ;
                }
            } else if (field.type === 'selection'){
                this.input = document.createElement("SELECT") ;
                this.input.className = "form-control" ;
                this.input.appendChild(document.createElement("OPTION")) ;
                if(Array.isArray(field.values)){
                    for(let val of field.values){
                        const opt = document.createElement("OPTION") ;
                        opt.value = val;
                        const trKey = "values."+this.currentModel+"."+val ;
                        const valTranslated = window.tr(trKey) ;
                        if(valTranslated !== trKey){
                            opt.innerHTML = valTranslated;
                        }else{
                            opt.innerHTML = val;
                        }
                        this.input.appendChild(opt);
                    }
                }else if(field.values){
                    (field.valuesKeys||Object.keys(field.values)).forEach((v)=>{
                        const opt = document.createElement("OPTION") ;
                        opt.value = v;
                        if(this.currentModel[0]==="{"){
                            //manual field
                            opt.innerHTML = field.values[v];
                        }else{
                            const trKey = "values."+this.currentModel+"."+v ;
                            const valTranslated = window.tr(trKey) ;
                            if(valTranslated !== trKey){
                                opt.innerHTML = valTranslated;
                            }else{
                                opt.innerHTML = field.values[v];
                            }
                        }
                        this.input.appendChild(opt);
                    }) ;
                }
            } else if (field.type === 'array-selection'){
                this.input = document.createElement("z-checkbox-list") ;
                const options = [] ;
                if(Array.isArray(field.values)){
                    for(let val of field.values){
                        const trKey = "values."+this.currentModel+"."+val ;
                        const valTranslated = window.tr(trKey) ;
                        options.push({
                            id: val,
                            label: valTranslated !== trKey?valTranslated:val
                        }) ;
                    }
                }else if(field.values){
                    Object.keys(field.values).forEach((v)=>{
                        options.push({
                            id: v,
                            label: field.values[v]
                        }) ;
                    }) ;
                }
                this.input.setAttribute("z-field-id", "id") ;
                this.input.setAttribute("z-label-fields", "label") ;
                this.input.setAttribute("z-options", JSON.stringify(options)) ;
            } else if (field.type === 'search' || field.type === "reference" || field.type === "user"){
                this.input = document.createElement("z-search") ;
                if(this.hasAttribute("z-search-choose-label")){
                    this.input.setAttribute("z-search-choose-label", this.getAttribute("z-search-choose-label")) ;
                }
                if(this.hasAttribute("z-no-empty-search")){
                    this.input.setAttribute("z-no-empty-search", this.getAttribute("z-no-empty-search")) ;
                }
                if(this.hasAttribute("z-form-url")){
                    this.input.setAttribute("z-form-url", this.getAttribute("z-form-url")) ;
                }
                if(this.hasAttribute("z-form-create-url")){
                    this.input.setAttribute("z-form-create-url", this.getAttribute("z-form-create-url")) ;
                }
                if(this.hasAttribute("z-form-popup-size")){
                    this.input.setAttribute("z-form-popup-size", this.getAttribute("z-form-popup-size")) ;
                }
                
                this.computeSearchQuery();

                this.input.setAttribute("z-label-fields", field.references.label) ;
                this.input.setAttribute("z-field-id", field.references.column) ;
                if(field.references.no_empty_search){
                    this.input.setAttribute("z-no-empty-search", "true") ;
                }
            } else if (field.type === 'one2many'){
                this.input = document.createElement("z-list") ;
                this.input.setAttribute("z-edit-autosave", false) ;
                this.input.setAttribute("z-open-url", this.getAttribute("z-open-url")||"") ;
                if(this.hasAttribute("z-no-new-line-auto")){
                    this.input.setAttribute("z-no-new-line-auto", "true") ;
                }
                // this.input.setAttribute("z-model", field.one2many.model) ;
                // this.input.setAttribute("z-filter", field.one2many.column+"=${_id}") ;
                this.input.setAttribute("z-buttons", '[]') ;
                this.setAttribute("z-no-auto-update", "true") ;
                let urlBase = "/api/rest" ;
                if(this.hasAttribute("z-app")){
                    urlBase = "/api/"+this.getAttribute("z-app")+"/rest" ;
                }
                this.setAttribute("z-bind-url", urlBase+"/"+field.one2many.model+"?"+field.one2many.column+"=${_id}") ;
                
                const modelDef = schema.models.find(m => m.name === field.one2many.model) ;
                if(!this.cols || this.cols.length === 0){
                    const columnDefs= modelDef.columns.map((c)=> { 
                        c.tableName = modelDef.name ;
                        const colDef = createColDef(c, this.getAttribute("z-app")) ;
                        colDef.editable = true;
                        if(c.name[0] === "_" || c.name === field.one2many.column){
                            colDef.hide = true ;
                        }
                        return colDef ;
                    }) ;
                    const funcName = "getFieldColDef"+uuidv4().replace(/-/g, "") ;
                    window[funcName] = function(){
                        return columnDefs ;
                    } ;
                    this.input.setAttribute("z-col-def", "window."+funcName+"()") ;
                }else{
                    for(let col of this.cols){
                        const colField = col.getAttribute("ag-field") ;
                        if(colField && modelDef){
                            const schemaColumn = modelDef.columns.find(c => c.name === colField) ;
                            if(schemaColumn){
                                col.setAttribute("z-model", modelDef.name+"."+colField) ;
                            }
                        }
                        this.input.appendChild(col) ;
                    }
                }
            } else if (field.submodel){
                this.input = document.createElement("z-list") ;
                this.input.setAttribute("z-edit-autosave", false) ;
                this.input.setAttribute("z-open-url", this.getAttribute("z-open-url")||"") ;
                this.input.setAttribute("z-buttons", '[]') ;
                this.setAttribute("z-no-auto-update", "true") ;
                
                const modelDef = field.submodel ;
                const columnDefs= modelDef.columns.map((c)=> { 
                    c.tableName = modelDef.path ;
                    const colDef = createColDef(c, this.getAttribute("z-app")) ;
                    colDef.editable = true;
                    if(c.name[0] === "_"){
                        colDef.hide = true ;
                    }
                    return colDef ;
                }) ;
                const funcName = "getFieldColDef"+uuidv4().replace(/-/g, "") ;
                window[funcName] = function(){
                    return columnDefs ;
                } ;
                this.input.setAttribute("z-col-def", "window."+funcName+"()") ;
            } else if (field.type === 'suggest'){
                throw "type "+field.type+" not supported" ;
            } else if (field.type === 'textarea'){
                this.input = document.createElement("TEXTAREA") ;
                this.input.className = "form-control" ;
            } else if (field.type === "html") {
                this.input = document.createElement("z-html");
                this.input.setAttribute("z-html-type", field.htmlType || "basic") ;
                if(this.hasAttribute('value')){
                    this.input.setAttribute("value", this.getAttribute('value'));
                }
            } else if (field.type === "code-html") {
                this.input = document.createElement("z-code-editor");
                this.input.setAttribute("language", "html");
                if(this.hasAttribute("value")){
                    this.input.setAttribute("value", this.getAttribute('value'));
                }
            } else if (field.type === "javascript") {
                this.input = document.createElement("z-code-editor");
                this.input.setAttribute("language", "javascript");
            }else if (field.type === "css") {
                this.input = document.createElement("z-code-editor");
                this.input.setAttribute("language", "css");
            } else if (field.type === "compose-html") {
                this.input = document.createElement("z-composer");
                if(this.hasAttribute('value')){
                    this.input.setAttribute("value", this.getAttribute('value'));
                }
            }else if (field.type === "sequence") {
                this.input = document.createElement("z-format");
                this.input.className = "form-text" ;
            }else if (field.type === "uuid") {
                this.input = document.createElement("input");
                this.input.setAttribute("readonly", "readonly");
                this.input.className = "form-control-plaintext";
            }
            else{
                throw "type "+field.type+" not supported" ;
            }

            // if(this.hasAttribute("z-bind")){
            //     this.input.setAttribute("z-bind", this.getAttribute("z-bind")) ;
            // }

            this.appendChild(this.input) ;
            if(this.customValidity){
                this.input.setCustomValidity(this.customValidity) ;
            }
            this.applyReadonly() ;
            this.applyRequired() ;
            this.applyPlaceholder() ;
        }

        computeSearchQuery(){
            const field = this.field ;

            if(!field){ return ; }

            let schema = window.APP.schema ;
            let urlBase = "/api/rest" ;
            if(this.hasAttribute("z-app")){
                urlBase = "/api/"+this.getAttribute("z-app")+"/rest" ;
                schema = window.APPS[this.getAttribute("z-app")].schema ;
            }


            const targetModel = schema.models.find(m => m.name === field.references.model) ;
            
            let searchedColumns = field.references.searchedColumns ;
            if(!searchedColumns){
                if(field.references.label.indexOf("{{") !== -1){
                    searchedColumns = [] ;
                    const extractResult = field.references.label.match(/{{([^}]+)}}/g) ;
                    if(extractResult){
                        for(let r=0; r<extractResult.length; r++){
                            searchedColumns.push(extractResult[r].replace(/^{{/, "").replace(/}}$/, "")) ;
                        }
                    }
                }else{
                    searchedColumns = [field.references.label.trim()] ;
                }
            }

            if(targetModel){
                searchedColumns = searchedColumns.filter(col=>{
                    let foundCol = targetModel.columns.find(c=>c.name===col) ;
                    return foundCol && foundCol.type === "string" ;
                }) ;
            }

            let urlResource = urlBase+"/"+getUrlOfLink2One(schema, field) ;
            // field.references.model ;

            // if(!field.references.joins){
            //     field.references.joins = [] ;
            // }

            // for(let join of field.references.joins){
            //     const alias = join.alias || join.target ;
            //     urlResource += "/joinone/"+join.target+"/as/"+alias ;
            // }

            // const modelDef = schema.models.find(m => m.name === field.references.model) ;
            // if(modelDef){
            //     for(let i=0; i<searchedColumns.length; i++){
            //         const colDef = modelDef.columns.find(c => c.name === searchedColumns[i]) ;
            //         if(colDef && colDef.references){
            //             const alias = colDef.name ;
            //             urlResource += "/joinone/"+colDef.references.model+"/as/"+alias ;
            //             field.references.joins.push({
            //                 alias: alias,
            //                 target: colDef.references.model
            //             }) ;
            //             if(colDef.references.label.includes("{{")){
            //                 field.references.label = field.references.label.replace(colDef.name, 
            //                     colDef.references.label.replace(/\{\{/g, "{{"+alias+".")) ;
            //             }else{
            //                 field.references.label = field.references.label.replace(colDef.name, 
            //                     alias+"."+colDef.references.label) ;
            //             }
            //         }
            //     }
            // }

            this.input.setAttribute("z-resource-url", urlResource) ;

            let search = { };
            for(let col of searchedColumns){
                search[col] = "%{{search}}%" ;
            }
            const searchLimit = this.getAttribute("z-search-limit") || field.references.searchLimit || 100;
            let searchQuery = {
                limit: searchLimit,
                $or: search
            } ;
            if(field.references.filter){
                search = [{$or:search}, field.references.filter] ;
                searchQuery = {
                    limit: searchLimit,
                    $and: search
                };
            }

            if(this.hasAttribute("z-search-filter")){
                //col=foo
                //col=foo/and/col2=bar
                //
                let pathWhere = [];
                const strSearchFilter = this.getAttribute("z-search-filter") ;
                const filterParts = strSearchFilter.split("/") ;
                let currentWhere = {} ;
                for(let part of filterParts){
                    if(currentWhere){
                        if(/\($/.test(part)){
                            currentWhere = {
                                $and: [
                                    currentWhere
                                ]
                            } ;
                            pathWhere.push(currentWhere) ;
                            let subWhere = {} ;
                            //operator $or or $and
                            let operator = "$"+part.substring(0, part.length-1).trim().toLowerCase() ;
                            subWhere[operator] = [] ;
                            currentWhere.$and.push(subWhere) ;
                            currentWhere = subWhere ;
                        }else if(part === ")"){
                            currentWhere = pathWhere.pop() ;
                        }else{
                            parseConditionPart(part, currentWhere) ;
                        }
                    }else{
                        if(/\($/.test(part)){
                            currentWhere = {
                                $and: []
                            } ;
                            pathWhere.push(currentWhere) ;
                            let subWhere = {} ;
                            //operator $or or $and
                            let operator = "$"+part.substring(0, part.length-1).trim().toLowerCase() ;
                            subWhere[operator] = [] ;
                            currentWhere.$and.push(subWhere) ;
                            currentWhere = subWhere ;
                        }else if(part === ")"){
                            throw "Closing parenthesis while not openned" ;
                        }else{
                            currentWhere = {$and: []} ;
                            parseConditionPart(part, currentWhere) ;
                        }
                    }
                }

                let searchFilter = currentWhere ;
                if(pathWhere.length>0){
                    searchFilter = pathWhere[0] ;
                }
                search = [{$or:search}, searchFilter] ;
                searchQuery = {
                    limit: searchLimit,
                    $and: search
                };
            }

            if(this.hasAttribute("z-search-order-by")){
                searchQuery.orderBy= this.getAttribute("z-search-order-by") ;
            }

            this.input.setAttribute("z-search-query", JSON.stringify(searchQuery)) ;
        }

        notifyChange(){
            if(this.input && this.input.notifyChange){
                this.input.notifyChange() ;
            }
        }

        static get observedAttributes() {
            return ['z-model', "readonly", "required", "pattern", "placeholder",
                "z-resource-url", "z-search-filter", "z-search-order-by", "z-col-def"];
        }

        attributeChangedCallback(name, oldValue, newValue) {
            switch (name) {
                case 'z-model':
                    if(oldValue !== newValue && this.parentElement && this.connected){
                        this.innerHTML = "";
                        this.initField() ;
                    }
                    break;
                case 'readonly':
                    this.applyReadonly();
                    break;
                case 'required':
                    this.applyRequired();
                    break;
                case 'placeholder':
                    this.applyPlaceholder();
                    break;
                case 'pattern':
                case 'z-col-def':
                    this.applyCopyAttr();
                    break;
                case 'z-resource-url':
                case 'z-search-filter':
                    this.computeSearchQuery();
                    break;
               
            }
        }

        applyCopyAttr(){
            if(this.input){
                [ "pattern", "z-col-def"].forEach((attr)=>{
                    if(this.hasAttribute(attr)){
                        this.input.setAttribute(attr, this.getAttribute(attr)) ;
                    }else{
                        this.input.removeAttribute(attr) ;
                    }
                }) ;
                let attrs = this.attributes ;
                for(let attr of attrs){
                    if([/^z-picker-option-/, /^z-mask-option-/].some(re=>re.test(attr.name))){
                        this.input.setAttribute(attr.name, attr.value) ;
                    }
                }
            }
        }

        get isArrayContainer(){
            return this.input && this.input.tagName === "Z-LIST" ;
        }

        get value() {
            if(this.input){
                if(this.field && this.field.type === "boolean"){
                    if(this.input.value === "true"){ return true ; }
                    if(this.input.value === "false"){ return false ; }
                    return null;
                }
                if(this.field && this.field.type === "checkbox"){
                    return this.input.checked ;
                }
                if(this.input.value === undefined){
                    return null;
                }
                return this.input.value ;
            }
            return null;
        }
        
        set value(value) {
            let valueModified = false ;
            if(value === null || value === undefined){
                if(this.hasAttribute("z-default-value")){
                    value = this.getAttribute("z-default-value") ;
                    valueModified = true;
                }else{
                    value = "" ;
                }
            }
            if(this.input && this.field && this.field.type === "checkbox"){
                if(value && typeof(value) === "string"){
                    value = value === "true" || value === "1" ;
                }
                this.input.checked = value;
            }else if(this.input && this.input.value !== value){
                this.input.value = value;
            }
            if(valueModified && this.updateValue){
                this.updateValue(value);
            }
        }


        get readonly() {
            return this.hasAttribute("readonly") ;
        }
        
        set readonly(readonly) {
            if(readonly){
                this.setAttribute('readonly', readonly);
            }else{
                this.removeAttribute('readonly');
            }
        }
        
        get required() {
            return this.hasAttribute("required") ;
        }
        
        set required(required) {
            if(required){
                this.setAttribute('required', required);
            }else{
                this.removeAttribute('required');
            }
        }
        
        get placeholder() {
            return this.getAttribute("placeholder") ;
        }
        
        set placeholder(placeholder) {
            this.setAttribute('placeholder', placeholder||"");
        }

        select(){
            if(this.input && this.input.select){
                this.input.select() ;
            }
        }
        checkValidity(){
            if(this.input && this.input.checkValidity){
                return this.input.checkValidity() ;
            }
            return true;
        }
        focus(){
            if(this.input && this.input.focus){
                this.input.focus() ;
            }
        }
        setValue(value){
            if(this.input){
                this.input.value = value; 
                this.input.dispatchEvent(new Event("change", {bubbles: true})) ;
            }
        }

        setCustomValidity(msg){
            this.customValidity = msg ;
            if(this.input){
                this.input.setCustomValidity(msg) ;
            }
        }

        applyReadonly(){
            const readonly = this.readonly ;

            const readonlyElements = ["input", "textarea", "select", "z-search", "z-list", "z-suggest"] ;
            for(let elName of readonlyElements){
                const els = this.querySelectorAll(elName) ;
                for(let i = 0; i<els.length; i++){
                    const el = els[i] ;
                    if(el.hasAttribute("z-never-readonly")){
                        continue;
                    }
                    if(readonly){
                        el.setAttribute("readonly", "readonly") ;
                        if(elName === "select" || (elName === "input" && this.field && ["checkbox", "color"].includes(this.field.type))) {
                            el.setAttribute("disabled", "disabled") ;
                        }
                    }else{
                        el.removeAttribute("readonly") ;
                        if(elName === "select" || (elName === "input" && this.field && ["checkbox", "color"].includes(this.field.type))) {
                            el.removeAttribute("disabled") ;
                        }
                    }
                }
            }

            if(this.input && this.field && this.field.type === "uuid") {
                this.input.setAttribute("readonly", "readonly");
            } else if(this.input){
                if(readonly){
                    this.input.setAttribute("readonly", "readonly") ;
                } else {
                    this.input.removeAttribute("readonly");
                }
            }
        }

        applyRequired(){
            const required = this.required ;

            // const requiredElements = ["input", "textarea", "select"] ;
            // for(let elName of requiredElements){
            //     const els = this.querySelectorAll(elName) ;
            //     for(let i = 0; i<els.length; i++){
            //         if(required){
            //             els[i].setAttribute("required", "required") ;
            //         }else{
            //             els[i].removeAttribute("required") ;
            //         }
            //     }
            // }
            if(this.input){
                if(required){
                    this.input.setAttribute("required", "required") ;
                }else{
                    this.input.removeAttribute("required") ;
                }
            }
        }

        applyPlaceholder(){
            const placeholder = this.placeholder||"" ;
            if(this.input){
                this.input.setAttribute("placeholder", placeholder) ;
            }
        }
    }
    customElements.define(COMPONENT_NAME, FieldOnlyComponent);
}
